import { RootState } from '@types';

export const selectModelsPageError = (state: RootState) => state.modelsPage.error;
export const selectIsModelsListLoading = (state: RootState) => state.modelsPage.isLoading;
export const selectModelsPageData = (state: RootState) => state.modelsPage.data;
export const selectModelsTotalCount = (state: RootState) => state.modelsPage.totalCount;
export const selectModelIds = (state: RootState) => state.modelsPage.selectedModelIds;
